import React, { useState } from 'react';
import {
  Box, Container, Typography, Chip, Card, CardContent, Button, Tabs, Tab,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import ConstructionBanner from '../components/ConstructionBanner';
import AdminViewBar from '../components/AdminViewBar';
import ThreeColumnLayout from '../components/sports/ThreeColumnLayout';
import { CollegeCompactStandings } from '../components/sports/CompactStandings';
import { CollegeGamesPanel } from '../components/sports/GamesPanel';
import { CollegeNewsGrid } from '../components/sports/CuratedNews';

const NAVBAR_H = 56;
const SUBNAV_H = 48;

const PLANNED = [
  { emoji: '📊', title: 'Player Stat Leaders',     desc: 'QB, RB, WR, TE leaders across all major FBS conferences.' },
  { emoji: '🤓', title: 'College Nerd Rating',     desc: 'The NR formula adapted for college — find the overlooked prospects.' },
  { emoji: '🏈', title: 'Team EPA by Conference',  desc: 'Which CFP contenders are efficient vs. padding stats against cupcakes?' },
  { emoji: '🎓', title: 'Draft Scouting',          desc: 'PBP-based metrics to surface draft prospects — production over hype.' },
  { emoji: '📈', title: 'Transfer Portal Tracker', desc: 'Impact analysis on portal moves — who actually upgrades their situation?' },
  { emoji: '🌳', title: 'Route Tree Analysis',     desc: 'Separation by route type for every college receiver worth watching.' },
];

function ComingSoonTab() {
  const navigate = useNavigate();
  return (
    <Box sx={{ py: 4, textAlign: 'center' }}>
      <Chip label="Coming Soon" color="secondary" sx={{ fontWeight: 800, mb: 2 }} />
      <Typography variant="h4" sx={{ fontWeight: 900, mb: 1.5 }}>College Football Analytics</Typography>
      <Typography sx={{ color: '#9eb8d0', maxWidth: 520, mx: 'auto', mb: 4, lineHeight: 1.7 }}>
        Same nerd-level PBP analytics as the NFL section — applied to college football. In development now.
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' }, gap: 2, mb: 4, textAlign: 'left', maxWidth: 800, mx: 'auto' }}>
        {PLANNED.map(f => (
          <Card key={f.title} sx={{ backgroundColor: 'rgba(10,20,34,0.7)', border: '1px dashed #2a4560', borderRadius: 2 }}>
            <CardContent sx={{ py: 2 }}>
              <Typography sx={{ fontSize: '1.4rem', mb: 0.75 }}>{f.emoji}</Typography>
              <Typography sx={{ fontWeight: 700, mb: 0.4, fontSize: '0.88rem' }}>{f.title}</Typography>
              <Typography variant="body2" sx={{ color: '#7a9ab8', lineHeight: 1.6, fontSize: '0.78rem' }}>{f.desc}</Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
      <Button variant="outlined" color="secondary" onClick={() => navigate('/in-the-works')}
        sx={{ textTransform: 'none', fontWeight: 600 }}>
        See Full Roadmap →
      </Button>
    </Box>
  );
}

const TABS = [
  { label: '📰 News',    id: 'news'    },
  { label: '📋 Coming Soon', id: 'soon' },
];

export default function CollegePage() {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'transparent' }}>
      <ConstructionBanner />
      <Navbar />

      {/* Sub-nav */}
      <Box sx={{
        backgroundColor: 'rgba(6,14,26,0.92)', backdropFilter: 'blur(8px)',
        borderBottom: '1px solid #1a2d3d',
        position: 'sticky', top: NAVBAR_H, zIndex: 1100,
      }}>
        <Container maxWidth="xl" sx={{ px: { xs: 0.5, sm: 2 } }}>
          <Tabs value={tab} onChange={(_, v) => setTab(v)}
            textColor="inherit" indicatorColor="primary"
            variant="scrollable" scrollButtons="auto"
            sx={{ minHeight: SUBNAV_H, '& .MuiTab-root': { minHeight: SUBNAV_H, fontWeight: 600, textTransform: 'none', fontSize: '0.88rem', px: 2 } }}>
            {TABS.map(t => <Tab key={t.id} label={t.label} />)}
          </Tabs>
        </Container>
      </Box>

      {/* Content */}
      <Container maxWidth="xl" sx={{ py: 3 }}>
        {tab === 0 ? (
          <ThreeColumnLayout
            left={<CollegeCompactStandings />}
            center={<CollegeNewsGrid />}
            right={<CollegeGamesPanel />}
          />
        ) : (
          <ComingSoonTab />
        )}
      </Container>

      <AdminViewBar />
    </Box>
  );
}
